

import React, {Component} from 'react'

import NotesToolbarButton from './toolbar/NotesToolbarButton'
import DispatchTimeToolbarButton from './toolbar/DispatchTimeToolbarButton'
import CustomerToolbarButton from './toolbar/CustomerToolbarButton'
import DiscountToolbarButton from './toolbar/DiscountToolbarButton'
import TableToolbarButton from './toolbar/TableToolbarButton'
import DriverToolbarButton from './toolbar/DriverToolbarButton'
import MenuToolbarButton from './toolbar/MenuToolbarButton'
import DiscardToolbarButton from './toolbar/DiscardToolbarButton'
import OptionsToolbarButton from './toolbar/OptionsToolbarButton'


class VToolbar extends Component 
{
    render()
    {
        let components = [];

        components.push(<div style={{marginBottom:'20px', borderBottom:'1px solid #00000040', width:"80%"}}/>)

        components.push(<NotesToolbarButton/>);
        components.push(<div style={{marginTop:'20px', marginBottom:'20px', borderBottom:'1px solid #00000040', width:"80%"}}/>)

        components.push(<CustomerToolbarButton/>);
        components.push(<div style={{marginTop:'20px', marginBottom:'20px', borderBottom:'1px solid #00000040', width:"80%"}}/>)

        components.push(<DiscountToolbarButton onEnteringVoucher={this.props.onEnteringVoucher}/>)
        components.push(<div style={{marginTop:'20px', marginBottom:'20px', borderBottom:'1px solid #00000040', width:"80%"}}/>)

        components.push(<TableToolbarButton/>)
        components.push(<div style={{marginTop:'20px', marginBottom:'20px', borderBottom:'1px solid #00000040', width:"80%"}}/>)

        components.push(<DriverToolbarButton/>)
        components.push(<div style={{marginTop:'20px', marginBottom:'20px', borderBottom:'1px solid #00000040', width:"80%"}}/>)

        components.push(<DispatchTimeToolbarButton/>)
        components.push(<div style={{marginTop:'20px', marginBottom:'20px', borderBottom:'1px solid #00000040', width:"80%"}}/>)

        components.push(<MenuToolbarButton/>)   
        components.push(<div style={{marginTop:'20px', marginBottom:'20px', borderBottom:'1px solid #00000040', width:"80%"}}/>)

        components.push(<OptionsToolbarButton/>)
        components.push(<div style={{marginTop:'20px', marginBottom:'20px', borderBottom:'1px solid #00000040', width:"80%"}}/>)
        
        components.push(<DiscardToolbarButton/>)
        components.push(<div style={{marginTop:'20px', borderBottom:'1px solid #00000040', width:"80%"}}/>)   

        return <div className='h-100 w-100 d-flex flex-column justify-content-center align-items-center' style={{padding:'5px',
                                                    borderLeft:'1px solid var(--colors-neutral)', 
                                                    borderRight:'1px solid var(--colors-neutral)',
                                                    background:'white',
                                                    overflowY:'auto',
                                                    }}>
                    {components}
               </div>
    }
}

export default VToolbar